import { NgModule } from '@angular/core';
import { ExpepharmaScrollbarDirective } from '@expepharma/directives/scrollbar/scrollbar.directive';

@NgModule({
    declarations: [ExpepharmaScrollbarDirective],
    exports: [ExpepharmaScrollbarDirective],
})
export class ExpepharmaScrollbarModule {}
